import faq from "@/content/faq.json";
import Reveal from "@/components/home/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export const FAQ = () => (
  <section id="faq" className="mt-section bg-white" data-testid="faq-section">
    <div className="mt-container grid lg:grid-cols-[0.8fr_1.2fr] gap-10">
      <Reveal>
        <p className="text-brand-orange font-semibold text-sm uppercase tracking-wider">FAQ</p>
        <h2 className="mt-2 text-3xl sm:text-4xl lg:text-5xl leading-tight">Preguntas que nos hacen todos los días.</h2>
        <p className="mt-4 text-gray-600">¿Tienes otra? Escríbele a Richard por WhatsApp y te contesta él mismo.</p>
      </Reveal>
      <Reveal delay={120}>
        <Accordion type="single" collapsible className="divide-y divide-orange-100 rounded-3xl border border-orange-100 bg-brand-cream/50 px-6" data-testid="faq-accordion">
          {faq.map(({ q, a }, i) => (
            <AccordionItem key={q} value={`faq-${i}`} className="border-0" data-testid={`faq-item-${i + 1}`}>
              <AccordionTrigger className="text-left text-base sm:text-lg font-semibold font-heading hover:no-underline hover:text-brand-orange py-5 [&[data-state=open]]:text-brand-orange" data-testid={`faq-trigger-${i + 1}`}>{q}</AccordionTrigger>
              <AccordionContent className="text-gray-600 text-base leading-relaxed pb-5" data-testid={`faq-content-${i + 1}`}>{a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);

export default FAQ;
